export enum SubscriptionPaymentStatusTypes {
	Pending = 0,
	Succeeded = 1,
	Failed = 2,
	Refunded = 3,
}

export enum TransactionPaymentKind {
	Subscription = 0,
	Pack = 1,
}

const paymentStatusByName: Record<string, SubscriptionPaymentStatusTypes> = {
	Pending: SubscriptionPaymentStatusTypes.Pending,
	Succeeded: SubscriptionPaymentStatusTypes.Succeeded,
	Failed: SubscriptionPaymentStatusTypes.Failed,
	Refunded: SubscriptionPaymentStatusTypes.Refunded,
}

const paymentKindByName: Record<string, TransactionPaymentKind> = {
	Subscription: TransactionPaymentKind.Subscription,
	Pack: TransactionPaymentKind.Pack,
}

/** API may return enum as number or string name depending on serializer settings. */
export function normalizePaymentStatus(status: SubscriptionPaymentStatusTypes | string | number): SubscriptionPaymentStatusTypes {
	if (typeof status === 'number') return status
	if (typeof status === 'string') {
		if (status in paymentStatusByName) return paymentStatusByName[status]
		const parsed = Number(status)
		if (!Number.isNaN(parsed)) return parsed as SubscriptionPaymentStatusTypes
	}
	return SubscriptionPaymentStatusTypes.Pending
}

export function normalizePaymentKind(kind: TransactionPaymentKind | string | number | undefined): TransactionPaymentKind {
	if (typeof kind === 'number') return kind
	if (typeof kind === 'string') {
		if (kind in paymentKindByName) return paymentKindByName[kind]
		const parsed = Number(kind)
		if (!Number.isNaN(parsed)) return parsed as TransactionPaymentKind
	}
	return TransactionPaymentKind.Subscription
}

/** Query-string value that ASP.NET string-enum binding accepts. */
export function toPaymentKindQuery(kind: TransactionPaymentKind | string | number | undefined): 'Subscription' | 'Pack' {
	return normalizePaymentKind(kind) === TransactionPaymentKind.Pack ? 'Pack' : 'Subscription'
}

export interface SearchAdminTransactionsRequest {
	pageNumber: number
	pageSize: number
	sortField?: string
	sortOrder?: string
	paymentStatus?: SubscriptionPaymentStatusTypes
	dateFrom?: string
	dateTo?: string
	tenantId?: number
	keyword?: string
}

export interface AdminTransactionListResponse {
	id: number
	kind: TransactionPaymentKind | string
	tenantId: number
	tenantName: string
	tenantAdminEmail: string
	tenantSubscriptionPlanId: number
	planName: string
	amount: number
	currency: string
	paymentStatus: SubscriptionPaymentStatusTypes | string
	stripePaymentIntentId?: string
	invoiceUrl?: string
	purchasedByUserId?: string
	createdOn: string
}

export interface TransactionAnalyticsSummaryResponse {
	totalCount: number
	succeededCount: number
	failedCount: number
	pendingCount: number
	refundedCount: number
	succeededAmount: number
	currency: string
}

export interface PaginationResponse<T> {
	data?: T[]
	totalCount?: number
	currentPage?: number
	pageSize?: number
	totalPages?: number
	hasPreviousPage?: boolean
	hasNextPage?: boolean
}

export interface TransactionPromoCodeDetail {
	promoCodeId: number
	code: string
	description?: string | null
	discountType: string | number
	discountValue: number
	originalAmount: number
	discountAmount: number
	finalAmount: number
	usedOn: string
}

export interface TransactionDetailResponse {
	id: number
	kind: TransactionPaymentKind | string
	tenantId: number
	tenantName: string
	tenantAdminEmail: string
	tenantSubscriptionPlanId: number
	planName: string
	packName?: string | null
	userCount?: number | null
	instanceCount?: number | null
	databaseCount?: number | null
	amount: number
	currency: string
	paymentStatus: SubscriptionPaymentStatusTypes | string
	stripePaymentIntentId?: string
	invoiceUrl?: string
	purchasedByUserId?: string
	createdOn: string
	promoCode?: TransactionPromoCodeDetail | null
}
